import { SocialShare } from './social-share';

export class TwitterShare extends SocialShare {
  protected generateShareUrl(): string {
    return `https://twitter.com/share?url=${encodeURIComponent(this.url)}`;
  }
}
